import { render, staticRenderFns } from "./myBots.vue?vue&type=template&id=a7954d68&scoped=true&lang=pug&"
import script from "./myBots.vue?vue&type=script&lang=js&"
export * from "./myBots.vue?vue&type=script&lang=js&"
import style0 from "./myBots.vue?vue&type=style&index=0&id=a7954d68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7954d68",
  null
  
)

export default component.exports